import { Icon } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Fab from '@material-ui/core/Fab';
import Slide from '@material-ui/core/Slide';
import * as React from 'react';
import { Translator } from '~domain/i18n';
import { styled } from '~ui-kit/styled-components';
import { Img } from './img.component';
import { Subtitle2, Subtitle3 } from './typography.component';

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const Logo = styled(Img)`
  flex-grow: 1;
  position: relative;
`;

interface Props {
  homeButtonHref: string;
  srcImg: string; // Image path
  translator: Translator;
}

export const BrowserNotSupported: React.SFC<Props> = ({ homeButtonHref, srcImg, translator: { t } }) => {
  return (
    <Dialog
      open={true}
      TransitionComponent={Transition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <Subtitle2 m={4} fontSize={'28px'} textAlign={'center'} fontWeight={'bold'} lineHeight={'38px'}>
        {t('notSupported.title')}
      </Subtitle2>
      <DialogContent>
        <Subtitle3 mb={4} fontSize={'18px'} textAlign={'center'} lineHeight={'24px'}>
          {t('notSupported.description')}
        </Subtitle3>

        <div style={{ textAlign: 'center' }}>
          <Logo mb={[4]} width={'173px'} height={'190px'} src={srcImg} />
        </div>
        <div style={{ textAlign: 'center', paddingBottom: '24px' }}>
          <Fab variant="extended" size="large" type="link" href={homeButtonHref}>
            {t('buttons.home')}
            <Icon>chevron_right</Icon>
          </Fab>
        </div>
      </DialogContent>
    </Dialog>
  );
};
